export default __webpack_public_path__ + "static/media/ajsBayou.ba4c920a.png";